import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0V0z" fill="none" /><path d="M17 6H7a6 6 0 000 12h10a6 6 0 000-12zm0 10H7a4 4 0 110-8h10a4 4 0 110 8zM7 9a3 3 0 100 6 3 3 0 000-6z" /></svg>;